import React from "react"
import { Link } from "gatsby"

const IconBuilding = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="9" y1="3" x2="9" y2="21" /><line x1="3" y1="9" x2="21" y2="9" />
  </svg>
)

const IconUsers = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

const IconBriefcase = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
)

const NAV_ITEMS = [
  {
    to: "/about",
    Icon: IconBuilding,
    title: "About Us",
    desc: "Partnering with visionary businesses since 2018, built on trust and results.",
    bg: "#eff6ff",
    ic: "#1b2d8e",
  },
  {
    to: "/lifeAtVisiomate",
    Icon: IconUsers,
    title: "Life at Visiomate",
    desc: "A workplace that values positivity, community, and employee growth.",
    bg: "#fff7ed",
    ic: "#ea580c",
  },
  {
    to: "/career",
    Icon: IconBriefcase,
    title: "Careers",
    desc: "Join our growing team and be part of our journey to excellence.",
    bg: "#f0fdf4",
    ic: "#16a34a",
  },
]

const HIGHLIGHTS = [
  "50+ projects delivered across 4 continents",
  "Founder-led engagement on every project",
  "8+ years of production software expertise",
  "Trusted by US, European & Middle East clients",
]

const KnowUs = () => (
  <div className="mega-menu">
    <div className="mega-menu__left" style={{ width: "240px" }}>
      <p className="mega-menu__section-label">Company</p>
      {NAV_ITEMS.map(({ to, Icon, title, desc, bg, ic }) => (
        <Link key={to} to={to} className="mega-menu__nav-item">
          <div className="mega-menu__nav-icon" style={{ background: bg }}>
            <Icon style={{ color: ic }} />
          </div>
          <div className="mega-menu__nav-text">
            <strong>{title}</strong>
            <span>{desc}</span>
          </div>
        </Link>
      ))}
    </div>

    <div className="mega-menu__right" style={{ flex: 1, borderLeft: "1px solid #e5e7eb", paddingLeft: "2rem", width: "auto" }}>
      <p className="mega-menu__section-label">Why Visiomate</p>
      <div style={{ marginBottom: "1rem" }}>
        {HIGHLIGHTS.map(h => (
          <div key={h} className="mega-menu__highlight-item">
            <span className="mega-menu__check">✓</span>
            <span>{h}</span>
          </div>
        ))}
      </div>
      <Link to="/contact" className="mega-menu__cta-link">Book a Free Consultation →</Link>
    </div>
  </div>
)

export default KnowUs
